import * as Yup from 'yup';

import { getValidationRules } from '../../../../validation';
import { RequestServiceInitialValues } from '../../SolarContact.types';
// @ts-ignore
import general from './meta/general.json';

export const initialValues: RequestServiceInitialValues = {
  enquiryType: "",
  comment: "",
  address: '',
  streetNumber: "",
  streetName: "",
  suburb: "",
  state: "",
  postcode: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  allowMarketingCommunications: false
};

export const validation = Yup.object().shape({
  ...getValidationRules(general)
});
